import React from 'react';

import { useSelector } from 'react-redux';

import Button from '../commons/Button';

import { LOGO_HREF } from '../../constants/constants';

import invoiceReferenceImage from '../../assets/photos/facturacion-gs-1-min.png';

const FormEnding = () => {
  const policyNumber = useSelector((state) => state.form6.numberPolicy);
  const isPaid = useSelector((state) => state.form7.isPaid);
  const policy = useSelector((state) => state.formEnding.urls.policy);
  const rcusa = useSelector((state) => state.formEnding.urls.rcusa);
  const receipt = useSelector((state) => state.formEnding.urls.receipt);
  const endoso = useSelector((state) => state.formEnding.urls.endoso);
  const bienvenida = useSelector((state) => state.formEnding.urls.bienvenida);

  const onClickDownload = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="quoter-form -form-ending">
      <h2 className="form-title text-center">
        { isPaid ? '¡Felicidades por comprar un seguro para tu auto!'
          : '¡Felicidades, ya estás asegurado! Garantiza la vigencia de tu póliza.' }
      </h2>
      <h3>Póliza</h3>
      <hr className="solid" />
      Número de póliza:&nbsp;
      <b>{policyNumber}</b>
      {!isPaid && (
        <p className="form-regular-text">
          <span className="bold-text">
            Tu pago no se ha podido procesar. Para evitar la cancelación de tu póliza puedes&nbsp;
            realizar otro intento de pago dentro de 24 horas
          </span>
          , en la siguiente liga&nbsp;
          <a href="https://generaldeseguros.mx/pagos-en-linea/" target="_blank" rel="noreferrer">
            https://generaldeseguros.mx/pagos-en-linea
          </a>
          &nbsp;o bien consultar nuestros diversos medios de pago que se encuentran dentro de tu recibo.
        </p>
      )}
      <h3 className="mt-40">¡Descarga tus documentos!</h3>
      <div className="form-buttons -align-left">
        <div className="field-row -align-left">
          {
            policy && (
              <div className="field -multiple-button">
                <Button
                  label="Carátula Póliza"
                  type="button"
                  buttonClasses="-secondary-primary-color "
                  onClick={() => onClickDownload(policy)}
                  iconPosition="before"
                  iconClasses="download" />
              </div>
            )
          }
          {
            receipt && (
              <div className="field -multiple-button">
                <Button
                  label="Recibo"
                  type="button"
                  onClick={() => onClickDownload(receipt)}
                  buttonClasses="-secondary-primary-color "
                  iconPosition="before"
                  iconClasses="download" />
              </div>
            )
          }
          {
            rcusa && (
              <div className="field -multiple-button">
                <Button
                  label="RC USA"
                  type="button"
                  onClick={() => onClickDownload(rcusa)}
                  buttonClasses="-secondary-primary-color "
                  iconPosition="before"
                  iconClasses="download" />
              </div>
            )
          }
          {
            endoso && (
              <div className="field -multiple-button">
                <Button
                  label="Endoso"
                  type="button"
                  onClick={() => onClickDownload(endoso)}
                  buttonClasses="-secondary-primary-color "
                  iconPosition="before"
                  iconClasses="download" />
              </div>
            )
          }
          {
            bienvenida && (
              <div className="field -multiple-button">
                <Button
                  label="Bienvenida"
                  type="button"
                  onClick={() => onClickDownload(bienvenida)}
                  buttonClasses="-secondary-primary-color "
                  iconPosition="before"
                  iconClasses="download" />
              </div>
            )
          }
        </div>
      </div>

      <h3>Información importante para los pagos de tu póliza:</h3>
      <p className="form-regular-text">
        Si tu frecuencia de pago es fraccionado, deberás generar tus recibos de pago subsecuentes,&nbsp;
        con tu número de póliza desde la siguiente liga&nbsp;
        <a href="https://generaldeseguros.mx/pagos-en-linea/" target="_blank" rel="noreferrer">https://generaldeseguros.mx/pagos-en-linea</a>
        &nbsp;24 horas posteriores a la aplicación de tu último pago.
      </p>

      <h3>¿Requieres factura?</h3>
      <p className="form-regular-text">
        Si requieres factura, a partir de las 12 horas del día de mañana podrás ingresar a la página&nbsp;
        <a href="https://www.generaldeseguros.mx" target="_blank" rel="noreferrer">www.generaldeseguros.mx</a>
        &nbsp;y capturar tus datos fiscales para que se genere de forma automática.
        &nbsp;Te sugerimos solicitarla dentro de las primeras 24 horas.
      </p>
      <div className="text-center">
        <a href="https://www.generaldeseguros.mx" target="_blank" rel="noreferrer">
          <img
            className="invoice-generation-link"
            src={invoiceReferenceImage}
            alt="Link hacia facturación General de Seguros" />
        </a>
      </div>

      <h3>Conoce más información relacionada con tu póliza en el apartado de clientes</h3>
      <a className="url-insurance" href="https://www.generaldeseguros.mx/home/clientes" target="_blank" rel="noreferrer">
        www.generaldeseguros.mx/home/clientes
      </a>
      <div className="my-50">
        <Button
          buttonClasses="align-center new-quote"
          type="link"
          href={LOGO_HREF}
          label="Nueva Cotización"
          iconPosition="none" />
      </div>
    </div>
  );
};

export default FormEnding;
